module.exports = __webpack_public_path__ + "img/header-logo.27b036ce.svg";